import { render } from "./Group_permissions.vue?vue&type=template&id=ba35d820&scoped=true"
import script from "./Group_permissions.vue?vue&type=script&lang=js"
export * from "./Group_permissions.vue?vue&type=script&lang=js"

import "./Group_permissions.vue?vue&type=style&index=0&id=ba35d820&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba35d820"]])

export default __exports__